import Base from '@/resources/Base'
import { formatFromNow } from '@/utilities/datetime.helper'

export default class Notification extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)

    this.details = {
      createdOn: this.created_on,
      eventAction: this.event_action,
      eventCategory: this.event_category,
      eventResourceId: this.event_resource_id,
      eventType: this.event_type
    }

    this.dwellTime = formatFromNow(this.details.createdOn, {
      years: { enabled: true, unit: 'y' },
      months: { enabled: true, unit: 'm' },
      days: { enabled: true, unit: 'd' },
      hours: { enabled: true, unit: 'h' },
      minutes: { enabled: true, unit: 'm' },
      seconds: { enabled: true, unit: 's' }
    })
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/notification/Notification.js